export const jobSchema = {
    "$schema": "http://json-schema.org/draft-07/schema#",
    "$id": "JobsSchema",
    "title": "Jobs Schema",
    "type": "object",
    "required": ["barcode", "tallyNumber", "tally_number", "weight", "weight_lbs_ft", "grade", "material", "makeUpLoss", "mul",
        "totalLength", "total_length", "drift", "drift_inch", "status", "pipe_status", "locationStatus", "location", "effective_length", "effectiveLength",
        "wallThickness", "wall", "type"],
    "properties": {
        "barcode": {
            "$id": "#/properties/barcode",
            "type": "string",
            "minLength": 1
        },
        "tallyNumber": {
            "$id": "#/properties/tallyNumber",
            "type": "string",
            "minLength": 1
        },
        "tally_number": {
            "$id": "#/properties/tally_number",
            "type": "string",
            "minLength": 1
        },
        "weight": {
            "$id": "#/properties/weight",
            "type": "number",
            "minLength": 1
        },
        "weight_lbs_ft": {
            "$id": "#/properties/weight_lbs_ft",
            "type": "number",
            "minLength": 1
        },
        "grade": {
            "$id": "#/properties/grade",
            "type": "string",
            "minLength": 1
        },
        "material": {
            "$id": "#/properties/material",
            "type": "string",
            "minLength": 1
        },
        "makeUpLoss": {
            "$id": "#/properties/makeUpLoss",
            "type": "number",
            "minLength": 1
        },
        "mul": {
            "$id": "#/properties/mul",
            "type": "number",
            "minLength": 1
        },
        "totalLength": {
            "$id": "#/properties/totalLength",
            "type": "number",
            "minLength": 1
        },
        "total_length": {
            "$id": "#/properties/total_length",
            "type": "number",
            "minLength": 1
        },
        "drift": {
            "$id": "#/properties/drift",
            "type": "number",
            "minLength": 1
        },
        "drift_inch": {
            "$id": "#/properties/drift_inch",
            "type": "number",
            "minLength": 1
        },
        "status": {
            "$id": "#/properties/status",
            "type": "string",
            "minLength": 1
        },
        "pipe_status": {
            "$id": "#/properties/pipe_status",
            "type": "string",
            "minLength": 1
        },
        "locationStatus": {
            "$id": "#/properties/locationStatus",
            "type": "string",
            "minLength": 1
        },
        "location": {
            "$id": "#/properties/location",
            "type": "string",
            "minLength": 1
        },
        "effectiveLength": {
            "$id": "#/properties/effectiveLength",
            "type": "number",
            "minLength": 1
        },
        "effective_length": {
            "$id": "#/properties/effective_length",
            "type": "number",
            "minLength": 1
        },
        "wallThickness": {
            "$id": "#/properties/wallThickness",
            "type": "string",
            "minLength": 1
        },
        "wall": {
            "$id": "#/properties/wall",
            "type": "string",
            "minLength": 1
        },
        "type": {
            "$id": "#/properties/type",
            "type": "string",
            "minLength": 1
        },
        //fim das colunas obrigatórias
        "wallThicknessActual": {
            "$id": "#/properties/wallThicknessActual",
            "type": "number",
        },
        "id_job": {
            "$id": "#/properties/id_job",
            "type": "string"
        },
        "thread": {
            "$id": "#/properties/thread",
            "type": "string"
        },
        "connection": {
            "$id": "#/properties/connection",
            "type": "string"
        },
        "serial_number": {
            "$id": "#/properties/serial_number",
            "type": "integer"
        },
        "work_order": {
            "$id": "#/properties/work_order",
            "type": "string"
        },
        "workOrder": {
            "$id": "#/properties/workOrder",
            "type": "string"
        },
        "trackingNumber": {
            "$id": "#/properties/trackingNumber",
            "type": "string"
        },
        "ippn": {
            "$id": "#/properties/ippn",
            "type": "string"
        },
        "comments": {
            "$id": "#/properties/comments",
            "type": "string"
        },
        "product": {
            "$id": "#/properties/product",
            "type": "string"
        },
        "runningCompound": {
            "$id": "#/properties/runningCompound",
            "type": "string"
        },
        "compound_applied": {
            "$id": "#/properties/compound_applied",
            "type": "string"
        },
        "plannedSequenceNumber": {
            "$id": "#/properties/plannedSequenceNumber",
            "type": "number"
        },
        "planned_sequence": {
            "$id": "#/properties/planned_sequence",
            "type": "number"
        },
        "rejections": {
            "$id": "#/properties/rejections",
            "type": "string"
        },
        "reject_reason": {
            "$id": "#/properties/reject_reason",
            "type": "string"
        },
        "job_comments": {
            "$id": "#/properties/job_comments",
            "type": "string"
        },
        "cumulated_length": {
            "$id": "#/properties/cumulated_length",
            "type": "number"
        },
        "cumulatedLength": {
            "$id": "#/properties/cumulated_length",
            "type": "number"
        },
        "makeUp": {
            "$id": "#/properties/makeUp",
            "type": "number"
        },
        "make_up": {
            "$id": "#/properties/make_up",
            "type": "number"
        },
        "internalDiameter": {
            "$id": "#/properties/internalDiameter",
            "type": "number"
        },
        "id_inch": {
            "$id": "#/properties/id_inch",
            "type": "number"
        },
        "od_inch": {
            "$id": "#/properties/od_inch",
            "type": "number"
        },
        "outerDiameter": {
            "$id": "#/properties/outerDiameter",
            "type": "number"
        },
        "receive_status": {
            "$id": "#/properties/type",
            "type": "string"
        },
        "stand": {
            "$id": "#/properties/stand",
            "type": ["boolean", "string"]
        },
        "stand_sequence": {
            "$id": "#/properties/stand_sequence",
            "type": "integer"
        },
        "standPosition": {
            "$id": "#/properties/standPosition",
            "type": "integer"
        },
        "stand_number": {
            "$id": "#/properties/stand_number",
            "type": "integer"
        },
        "tally_details": {
            "$id": "#/properties/tally_details",
            "type": ["object", "string"]
        },
        "layer_position": {
            "$id": "#/properties/layer",
            "type": "number"
        },
        "pilePosition": {
            "$id": "#/properties/pilePosition",
            "type": "number"
        },
        "pileLayer": {
            "$id": "#/properties/pileLayer",
            "type": "number"
        },
        "layer": {
            "$id": "#/properties/layer",
            "type": "number"
        },
        "pileName": {
            "$id": "#/properties/pileName",
            "type": "string"
        },
        "pile": {
            "$id": "#/properties/pile",
            "type": "string"
        },
        "stand_order": {
            "$id": "#/properties/stand_order",
            "type": "number"
        },
        "scan_date": {
            "$id": "#/properties/scan_date",
            "type": "string",
            "format": "custom-date-time"
        },
        "receive_date": {
            "$id": "#/properties/receive_date",
            "type": "string",
            "format": "custom-date-time"
        },
        "customerPartNumber": {
            "$id": "#/properties/customerPartNumber",
            "type": "string"
        },
        "threadSpecialFeatures": {
            "$id": "#/properties/threadSpecialFeatures",
            "type": "string"
        },
        "boreVolume": {
            "$id": "#/properties/boreVolume",
            "type": "number"
        },
        "internalDiameterActual": {
            "$id": "#/properties/internalDiameterActual",
            "type": "number"
        },
        "pressureBurst": {
            "$id": "#/properties/pressureBurst",
            "type": "number"
        },
        "runningSequenceNumber": {
            "$id": "#/properties/properties",
            "type": "string"
        },
        "output_sequence": {
            "$id": "#/properties/output_sequence",
            "type": "string"
        },
        "vallourecId": {
            "$id": "#/properties/vallourecId",
            "type": "string"
        }
    },
    "errorMessage": {
        "properties": {
            "barcode": "Value for 'barcode' should be a String and cannot be null",
            "tallyNumber": "Value for 'tallyNumber' should be a String and cannot be null",
            "tally_number": "Value for 'tally_number' should be a String and cannot be null",
            "weight": "Value for 'weight' should be a Number and cannot be null",
            "weight_lbs_ft": "Value for 'weight_lbs_ft' should be a Number and cannot be null",
            "grade": "Value for 'grade' should be a String and cannot be null",
            "material": "Value for 'material' should be a String and cannot be null",
            "makeUpLoss": "Value for 'makeUpLoss' should be a Number and cannot be null",
            "mul": "Value for 'mul' should be a Number and cannot be null",
            "totalLength": "Value for 'totalLength' should be a Number and cannot be null",
            "total_length": "Value for 'total_length' should be a Number and cannot be null",
            "drift": "Value for 'drift' should be a Number and cannot be null",
            "drift_inch": "Value for 'drift_inch' should be a Number and cannot be null",
            "status": "Value for 'status' should be a String and cannot be null",
            "pipe_status": "Value for 'pipe_status' should be a String and cannot be null",
            "locationStatus": "Value for 'locationStatus' should be a String and cannot be null",
            "location": "Value for 'location' should be a String and cannot be null",
            "effective_length": "Value for 'effective_length' should be a Number and cannot be null",
            "effectiveLength": "Value for 'effective_length' should be a Number and cannot be null",
            "wallThickness": "Value for 'wallThickness' should be a String and cannot be null",
            "wall": "Value for 'wall' should be a String and cannot be null",
            "type": "Value for 'type' should be a String and cannot be null",
            //fim das colunas obrigatórias
            "id_job": "Value for 'id_job' should be a String",
            "thread": "Value for 'thread' should be a String",
            "connection": "Value for 'connection' should be a String",
            "serial_number": "Value for 'serial_number' should be a Number",
            "work_order": "Value for 'work_order' should be a String",
            "workOrder": "Value for 'workOrder' should be a String",
            "trackingNumber": "Value for 'trackingNumber' should be a String",
            "ippn": "Value for 'ippn' should be a String",
            "comments": "Value for 'comments' should be a String",
            "product": "Value for 'product' should be a String",
            "compound_applied": "Value for 'compound_applied' should be a String",
            "runningCompound": "Value for 'runningCompound' should be a String",
            "planned_sequence": "Value for 'planned_sequence' should be a Number",
            "plannedSequenceNumber": "Value for 'plannedSequenceNumber' should be a Number",
            "reject_reason": "Value for 'reject_reason' should be a String",
            "rejections": "Value for 'rejections' should be a String",
            "job_comments": "Value for 'job_comments' should be a String",
            "cumulated_length": "Value for 'cumulated_length' should be a Number",
            "cumulatedLength": "Value for 'cumulatedLength' should be a Number",
            "make_up": "Value for 'make_up' should be a Number",
            "makeUp": "Value for 'makeUp' should be a Number",
            "id_inch": "Value for 'id_inch' should be a Number",
            "internalDiameter": "Value for 'internalDiameter' should be a Number",
            "od_inch": "Value for 'od_inch' should be a Number",
            "outerDiameter": "Value for 'outerDiameter' should be a Number",
            "receive_status": "Value for 'receive_status' should be a String",
            "stand": "Value for 'stand' should be a boolean",
            "stand_sequence": "Value for 'stand_sequence' should be a Number",
            "standPosition": "Value for 'standPosition' should be a Number",
            "stand_number": "Value for 'stand_number' should be a Number",
            "tally_details": "Value for 'tally_details' should be a Object",
            "layer_position": "Value for 'layer_position' should be a Number",
            "pilePosition": "Value for 'pilePosition' should be a Number",
            "layer": "Value for 'layer' should be a Number",
            "pileLayer": "Value for 'pileLayer' should be a Number",
            "pile": "Value for 'pile' should be a String",
            "pileName": "Value for 'pileName' should be a String",
            "stand_order": "Value for 'stand_order' should be a Number",
            "scan_date": "Value for 'scan_date' should be a Date in format 'DD/MM/YYYY hh:mm:ss' or 'YYYY-MM-DDThh:mm:ss.SSSZ'",
            "receive_date": "Value for 'receive_date' should be a Date in format 'DD/MM/YYYY hh:mm:ss' or 'YYYY-MM-DDThh:mm:ss.SSSZ'",
            "customerPartNumber": "Value for 'customerPartNumber' should be a String",
            "threadSpecialFeatures": "Value for 'threadSpecialFeatures' should be a String",
            "boreVolume": "Value for 'boreVolume' should be a Number",
            "internalDiameterActual": "Value for 'boreVolume' should be a Number",
            "pressureBurst": "Value for 'pressureBurst' should be a Number",
            "runningSequenceNumber": "Value for 'runningSequenceNumber' should be a String",
            "output_sequence": "Value for 'output_sequence' should be a String",
            "vallourecId": "Value for 'vallourecId' should be a String",
            "wallThicknessActual": "Value for 'wallThicknessActual' should be a Number",
        },
    },
    "additionalProperties": true,
}